var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showApp)?_c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }